<template>
  <div class="group-buy-card">
    <template v-if="this.groupDetail.status === 2">
      <div class="header">
        还差<span class="header-num">{{groupPersonNum()}}</span>人就成团，快邀请好友一起来
      </div>
      <div class="time">
        <span class="time-text">距结束</span>
        <CommonTimer :end-time="endTime" @timerEnd="timerEnd"/>
      </div>
    </template>
    <template v-else>
      <div class="title">{{ groupStatusToText() }}</div>
    </template>

    <div class="person">
      <div v-for="(item, index) in personList" :key="index" class="person-item">
        <van-image
            round
            width="1.2rem"
            height="1.2rem"
            :src="item.userInfo && item.userInfo.avatar || require('../../../../assets/img/productDetail/default_head.png')"
        />
        <span class="text-overflow">{{ item.userInfo && (item.userInfo.nickName || item.userInfo.userName)  }}</span>
        <img src="../../../../assets/img/productDetail/icon_chief.png" alt="" v-if="item.isCaptain === 1" class="chief-img">
      </div>
    </div>
    <div class="footer">
      <CommonButton :value="{text: btnText()}" @click="openShare"/>
    </div>
    <DialogComponent ref="dialogComponent" :dialogType="dialogType"/>
  </div>
</template>

<script>
import Vue from 'vue';
import { Image as VanImage } from 'vant';
import { mapState } from 'vuex';
import moment from 'moment';
import CommonButton from '@/components/commonComponents/commonButton.vue';
import CommonTimer from '@/components/commonComponents/CommonTimer.vue';
import DialogComponent from '@/components/dialogComponent/dialogComponent.vue';
import { reqPostGroupCheck } from '@/api/courseDetail/groupBuy/groupBuy';
import { reqPrice } from '@/api/pay';
import { gioPlatform } from '@/utils/tools';

Vue.use(VanImage);

export default {
  components: {
    CommonButton,
    CommonTimer,
    DialogComponent,
  },
  props: {
    groupDetail: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      personList: [],
      dialogType: '',
      btnType: '',
      endTime: '', // 拼团团结束时间
      randomNickName: ['启小航ophdisns', '启小航DNncns', '时光巷陌', '南影倾寒', '启小航vdjosnds'],
    };
  },
  computed: {
    ...mapState(['userInfo', 'productSku']),
  },
  provide() {
    return {
      groupId: () => this.groupDetail.groupId,
    };
  },
  mounted() {
    // console.log(this.groupDetail);
    this.initPerson();
  },
  watch: {
  },
  methods: {
    timerEnd() {
      this.$parent.init();
    },
    initPerson() {
      const { groupOrderRespVOS } = this.groupDetail;
      this.personList = JSON.parse(JSON.stringify(groupOrderRespVOS)) || [];
      const personNum = this.groupDetail.groupNumber - this.personList.length;
      for (let i = 0; i < personNum; i += 1) {
        this.personList.push({
          userInfo: {
            nickName: this.groupDetail.status === 3 ? this.randomNickName[i] : '待邀请',
          },
        });
      }
    },
    groupPersonNum() {
      const { groupNumber, joinNumber } = this.groupDetail;
      const num = groupNumber - joinNumber;
      return num > 0 ? num : '';
    },
    btnText() {
      const { endTime, status, groupOrderRespVOS } = this.groupDetail;

      let text = '';
      if (status === 2) {
        this.endTime = moment(endTime).format('X');
      }
      if (status === 2 || status === 3) {
        // 判断是否为支付成功页跳转，打开弹窗 status 拼团中和拼团成功时打开弹窗
        const groupProgressStorage = sessionStorage.getItem('groupProgressSource');
        if ((groupProgressStorage && groupProgressStorage === 'cashier') || this.$route.query.from === 'app') {
          this.dialogType = 'groupBuySuccessDialog';
          this.$nextTick(() => {
            this.$refs.dialogComponent.show = true;
          });
          sessionStorage.removeItem('groupProgressSource');
        }
      }
      if (this.userInfo.id) {
        const user = {
          isCaptain: false,
          isParticipate: false,
        };
        // eslint-disable-next-line no-unused-expressions
        groupOrderRespVOS?.forEach((item) => {
          if (item.userId === this.userInfo.id) {
            user.isParticipate = true;
            user.isCaptain = item.isCaptain === 1;
          }
        });
        if (!this.groupDetail.groupActivityDiscountVOS && !user.isParticipate) {
          // 活动结束 且用户不在团中
          text = '去看看其他课程';
          this.btnType = 'openOtherCourse';
          return text;
        }
        if (status === 2) {
          // 拼团中
          if (user.isParticipate) {
            // 在团中
            text = '立即邀请';
            this.btnType = 'invite';
          } else {
            text = '参与拼团';
            this.btnType = 'joinGroup';
          }
        } else if (status === 3) {
          // 拼团成功
          if (user.isParticipate) {
            // 在团中
            text = '查看课程';
            this.btnType = 'openCourse';
          } else {
            text = '我也要开团';
            this.btnType = 'openNewGroup';
          }
        } else if (status === 4 || status === 5) {
          // 拼团失败或关闭团
          if (!this.groupDetail.groupActivityDiscountVOS) {
            // 活动结束
            text = '去看看其他课程';
            this.btnType = 'openOtherCourse';
          } else if (user.isParticipate && user.isCaptain) {
            text = '重新开团';
            this.btnType = 'openNewGroup';
          } else {
            text = '我要开团';
            this.btnType = 'openNewGroup';
          }
        }
      } else {
        if (!this.groupDetail.groupActivityDiscountVOS) {
          // 活动结束
          text = '去看看其他课程';
          this.btnType = 'openOtherCourse';
          return text;
        }
        // 未登录状态下
        // eslint-disable-next-line
        if (status === 2) {
          // 拼团中
          text = '参与拼团';
          this.btnType = 'joinGroup';
        } else if (status === 3) {
          // 拼团成功
          text = '我也要开团';
          this.btnType = 'openNewGroup';
        } else if (status === 4 || status === 5) {
          // 拼团失败或关闭团
          if (!this.groupDetail.groupActivityDiscountVOS) {
            // 活动已结束
            text = '去看看其他课程';
            this.btnType = 'openOtherCourse';
          } else {
            text = '我也要开团';
            this.btnType = 'openNewGroup';
          }
        }
      }
      return text;
    },

    async openShare() {
      if (this.btnType === 'invite') {
        if (!this.groupDetail.groupActivityDiscountVOS) {
          this.$toast('当前暂无库存，请稍后再试～');
          return;
        }
        if (this.$root.$data.isWeiXin) {
          this.$emit('openWechatOverlay');
        } else {
          this.dialogType = 'groupBuySuccessDialog';
          this.$refs.dialogComponent.show = true;
        }
      } else if (this.btnType === 'openNewGroup' || this.btnType === 'joinGroup') {
        if (!this.groupDetail.groupActivityDiscountVOS) {
          this.$toast('当前暂无库存，请稍后再试～');
          return;
        }
        if (!this.userInfo.id) {
          this.$router.push({
            path: '/registrationLogin',
            query: { redirect: '/groupProgress', ...this.$route.query },
          });
          return;
        }
        const checkParam = {
          productId: this.groupDetail.productId,
          productSkuId: this.productSku.productSkuId,
          groupActivityId: this.groupDetail.groupActivityId,
          groupId: this.btnType === 'joinGroup' ? this.groupDetail.groupId : '',
        };
        const res = await reqPostGroupCheck(checkParam);
        if (res.code !== 0) {
          this.$toast(res.msg || '活动验证失败');
          return;
        }
        // 开团
        const param = [
          {
            productId: this.groupDetail.productId,
            skuId: this.productSku.productSkuId,
            groupActivityId: this.groupDetail.groupActivityId,
            groupId: this.groupDetail.groupId,
            groupOrderType: this.btnType === 'joinGroup' ? 'joinGroup' : 'openGroup',
          },
        ];
        this.$router.push({
          path: '/payOrder',
          query: { product: JSON.stringify(param) },
        });
        this.gioDefault(this.groupDetail.productId, this.productSku.productSkuId);
      } else if (this.btnType === 'openOtherCourse') {
        // 活动到期，查看其他课程
        this.$router.push({
          path: '/',
        });
      } else if (this.btnType === 'openCourse') {
        // 拼团成功，查看课程
        if (this.$root.$data.isApp) {
          this.$sendToApp('goLearnCenterPage', false);
        } else {
          this.$router.push({
            path: '/personalCenter/mycourseList',
          });
        }
      }
    },

    // 不同拼团状态生成对应文案
    groupStatusToText() {
      const statusTextEnum = {
        1: '待开团',
        2: '拼团中',
        3: '拼团成功啦',
        4: '拼团失败',
        5: '拼团失败',
      };
      return statusTextEnum[this.groupDetail.status];
    },
    async gioDefault(productId, productSkuId) {
      const res = await reqPrice({
        promotionBasicPrice: {
          endPoint: this.$root.$data.isApp ? 2 : 3,
          platform: 1,
        },
        promotionProductSkuPriceList: [{
          productId,
          skuId: productSkuId,
        }],
      });
      if (res.code === 0) {
        const courseIdList = []; const courseNameList = [];
        const allianceId = []; const allianceName = [];
        const fullReductionId = []; const fullReductionName = [];
        const secondsKillNameList = [];
        const {
          orderPayPrice,
          orderTotalPrice,
          productCalculateResultRespList,
          fullDiscountPrice,
          unionDiscountPrice,
          unionCalculateResultRespList,
          promotionFullCalculateResultRespList,
          singleCalculateResultRespList,
        } = res.data;
        productCalculateResultRespList.forEach((element) => {
          courseIdList.push(element.productId);
          courseNameList.push(element.productName);
        });
        if (unionDiscountPrice) {
          unionCalculateResultRespList.forEach((element) => {
            allianceId.push(element.promotionId);
            allianceName.push(element.promotionName);
          });
        }
        if (fullDiscountPrice) {
          promotionFullCalculateResultRespList.forEach((element) => {
            fullReductionId.push(element.promotionId);
            fullReductionName.push(element.promotionName);
          });
        }
        if (singleCalculateResultRespList) {
          singleCalculateResultRespList.forEach((element) => {
            if (element.promotionLabel === 2 || element.promotionLabel === 3) {
              secondsKillNameList.push(element.promotionName);
            }
          });
        }
        // 立即购买埋点
        // eslint-disable-next-line
        gio('track', 'buyCourse_event', {
          courseIdList_var: courseIdList.toString(), // 课程 ID 列表
          courseNameList_var: courseNameList.toString(), // 课程名称列表
          courseTotalPrice_var: secondsKillNameList.length > 0 ? orderPayPrice : orderTotalPrice, // 课程总价
          isAlliance_var: unionDiscountPrice ? '是' : '否', // 是否参加联报
          allianceId_var: unionDiscountPrice ? allianceId.toString() : null, // 联报活动ID
          allianceName_var: unionDiscountPrice ? allianceName.toString() : null, // 联报活动名称
          allianceDiscountAmount_var: unionDiscountPrice || null, // 联报优惠金额
          isSecondsKill_var: secondsKillNameList.length > 0 ? '是' : '否', // 是否参加秒杀
          secondsKillNameList_var: secondsKillNameList.length > 0 ? secondsKillNameList.toString() : null, // 秒杀活动名称列表
          isFullReduction_var: fullDiscountPrice ? '是' : '否', // 是否参加满减
          fullReductionId_var: fullDiscountPrice ? fullReductionId.toString() : null, // 满减活动ID
          fullReductionName_var: fullDiscountPrice ? fullReductionName.toString() : null, // 满减活动名称
          fullReductionAmount_var: fullDiscountPrice || null, // 满减优惠金额
          platform_var: gioPlatform(),
        });
      }
    },

  },
};
</script>

<style scoped lang="scss">
.group-buy-card {
  margin-top: 22px;
  padding: 36px;
  text-align: center;
  background: white;
  border-radius: 14px;

  .header {
    margin-top: 7px;
    color: #333;
    font-weight: 500;
    font-size: 27px;
    line-height: 38px;

    .header-num {
      color: $theme_color;
    }
  }

  .time {
    display: flex;
    justify-content: center;
    margin-top: 27px;

    .time-text {
      margin-right: 10px;
      color: #333;
      font-weight: 400;
      font-size: 22px;
      line-height: 31px;
    }
  }

  .title {
    margin-top: 7px;
    color: #333;
    font-weight: 600;
    font-size: 25px;
    line-height: 36px;
  }

  .person {
    display: flex;
    justify-content: center;
    margin-top: 50px;

    .person-item {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 0 18px;

      span {
        display: block;
        width: 100px;
        margin-top: 16px;
        color: #787878;
        font-weight: 400;
        font-size: 22px;
        line-height: 31px;
      }

      .chief-img {
        position: absolute;
        top: 72px;
        left: -38px;
        width: 76px;
        height: 33px;
        margin-left: 50%;
      }
    }
  }

  .footer {
    margin-top: 54px;

    .common-button-component {
      padding: 16px 0;
    }
  }
}
</style>
